import { render, staticRenderFns } from "./CutPanel.vue?vue&type=template&id=3b83d744&scoped=true&"
import script from "./CutPanel.vue?vue&type=script&lang=js&"
export * from "./CutPanel.vue?vue&type=script&lang=js&"
import style0 from "./CutPanel.vue?vue&type=style&index=0&id=3b83d744&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b83d744",
  null
  
)

export default component.exports